module.exports = __webpack_public_path__ + "static/media/cases_3d_04e.9292814d.jpg";